import { Stack } from '@mui/material';
import { ReactNode } from 'react';

import { Switch } from '@/components/form/baseInputs/Switch';

export interface SnowflakeSyncToggleProps {
  label: string;
  enabled: boolean;
  onChange: () => void;
  disabled?: boolean;
  /** Manual sync control, shown only while the toggle is enabled. */
  syncButton?: ReactNode;
}

export function SnowflakeSyncToggle({
  label,
  enabled,
  onChange,
  disabled = false,
  syncButton,
}: SnowflakeSyncToggleProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={1}
    >
      <Switch
        labelPosition="right"
        value={enabled}
        label={label}
        onChange={onChange}
        disabled={disabled}
      />
      {enabled && syncButton}
    </Stack>
  );
}
